import { FontSize, fontSize } from "constants/fontSize";
import { newColors } from "constants/newColors";
import styled, { css } from "styled-components";
import { ArrowIosDownward } from "@styled-icons/evaicons-solid";
import { colors } from "constants/colors";

export type StyledSelectBoxProps = {
  type?: "filter";
  height?: string;
  width?: string;
  font?: FontSize;
};

export const StyledSelectBoxContainer = styled.div`
  display: inline-block;
  position: relative;
`;

export const StyledSelectBox = styled.select<StyledSelectBoxProps>`
  border-radius: 5px;
  padding: 0.5em 2em 0.5em 0.75em;
  appearance: none;
  box-sizing: border-box;
  cursor: pointer;
  outline: none;

  :disabled {
    cursor: default;
  }

  font-size: ${({ font }) => font || fontSize.small};
  height: ${({ height }) => height || "2rem"};
  width: ${({ width }) => width || "100%"};

  ${({ type }) => {
    switch (type) {
      case "filter":
        return css`
          font-weight: bold;
          color: ${newColors.text};
          border: 1px solid ${newColors.border};
        `;
      default:
        return css`
          background: ${colors.form.background};
          border: 0px;
          :disabled {
            background: ${colors.disable};
          }
          :focus {
            background: ${colors.form.focused};
          }
        `;
    }
  }}
`;

export const StyledDownward = styled(ArrowIosDownward)`
  width: 1em;
  color: ${newColors.text};
  position: absolute;
  top: 50%;
  right: 0.75em;
  transform: translateY(-50%);
  pointer-events: none;
`;
